import {IDatabasePropertyResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {IChartDashboardItemTypeInterfaces} from '@toolify/server/src/services/DashboardItemService/strategies/DashboardItemTypeStrategies/ChartDashboardItemTypeStrategy/types/IChartDashboardItemTypeInterfaces'

export function findDatabaseRowPropertyMetaDataByDatasetIndex(
  rowPropertyId: string,
  databaseRowPropertiesPayload: IChartDashboardItemTypeInterfaces['options']['rowPropertiesPayload'],
  databaseRowProperties: IDatabasePropertyResponseInstance[],
) {
  const rowProperty = databaseRowProperties?.find(property => property.id === rowPropertyId) || null
  const payload = databaseRowPropertiesPayload?.find(payload => payload.rowPropertyId === rowPropertyId) || null

  return {
    databaseRowPropertyValueType: rowProperty?.valueType || null,
    databaseRowPropertyOptions: rowProperty?.options || null,
    databaseRowPropertyAggregationType: payload?.aggregationType || null,
  }
}
